import React, { useState } from 'react';
import { FormControl, InputLabel, Select, OutlinedInput, Checkbox, ListItemText, MenuItem, FormHelperText } from '@mui/material';
import { isMobile } from 'react-device-detect';
import { styled } from '@mui/material/styles';

const CustomLabelInput = styled(InputLabel)(() => ({
  "& .MuiFormLabel-asterisk.MuiInputLabel-asterisk": {
    visibility: "hidden",
    "&::before": {
      content: '"*"',
      visibility: "visible",
    },
  },
}));

const MuiMultiSelect = ({
  label,
  options,
  onChange,
  value,
  widthValue,
  fullWidth = false,
  customSx = {},
  required = false,
  errorMessage,
  MenuProps,
  defaultValue,
}) => {
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState(false);

  const handleChange = (event) => {
    const selected = event.target.value;
    onChange(event);
    if (required && touched) {
      setError(selected.length === 0);
    }
  };

  const handleClose = () => {
    if (required) {
      setTouched(true);
      if (!value || value.length === 0) {
        setError(true);
      } else {
        setError(false);
      }
    }
  };

  return (
    <FormControl
      sx={{
        m: 1,
        width: isMobile ? (widthValue ? '100%' : 'auto') : '170px',
        paddingRight: isMobile && widthValue ? '20px' : '0px',
        ...customSx,
        '& .MuiInputLabel-root': {
          color: '#3F4949', // default label color
          fontFamily: 'Inter',
        },
        '& .MuiInputLabel-root.Mui-focused': {
          color: '#00696D', // color when selected/focused
        }
      }}
      required={required}
      error={error}
    >
      <CustomLabelInput id="demo-multiple-checkbox-label">{label}</CustomLabelInput> {/* Use CustomLabelInput here */}
      <Select
        labelId="demo-multiple-checkbox-label"
        id="demo-multiple-checkbox"
        multiple
        value={value || []}
        onChange={handleChange}
        onClose={handleClose}
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected.join(', ')}
        defaultValue={defaultValue}
        sx={{
          width: isMobile ? '100%' : '170px',
          float: 'right',
          color: '#6F7979',
          '.MuiOutlinedInput-root': {
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#6F7979'
            }
          },
          '.MuiSelect-select': {
            '&:focus': {
              borderColor: '##00696D'
            }
          }
        }}
        MenuProps={MenuProps}
      >
        {options !== null && options !== undefined && options.map((option) => (
          <MenuItem key={option} value={option} style={{ border: 'none', backgroundColor: 'transparent', maxHeight: '200px' }}>
            <ListItemText primary={option} />
            <Checkbox
              checked={value ? value.indexOf(option) > -1 : false}
              sx={{ color: '#6F7979', '&.Mui-checked': { color: '#00696D' } }}
            />
          </MenuItem>
        ))}
      </Select>
      {error && <FormHelperText>{errorMessage || 'Dette feltet er påkrevd'}</FormHelperText>}
    </FormControl>
  );
};

export default MuiMultiSelect;